import { useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import type { GetGSDecisionAssignees, GSAssigneeList } from './types';
import { MONITOR_LIST_TEXT } from '../../../lang';
import type { SelectOption } from '../../../../../components';

export const useGetAssignees = (): GetGSDecisionAssignees => {
  const { data, loading, error, refetch } = useQuery(
    gql`
      query {
        getGSAssigneeList {
          assigneeList {
            netId
            displayName
          }
        }
      }
    `,
    {
      fetchPolicy: 'network-only',
    },
  );

  const gsAssigneeList = (data?.getGSAssigneeList?.assigneeList ??
    []) as GSAssigneeList[];

  const gsAssigneeOption: SelectOption[] = gsAssigneeList.map(assignee => ({
    value: assignee.netId,
    label: `${assignee.displayName} (${assignee.netId})`,
  }));

  gsAssigneeOption.unshift({
    value: MONITOR_LIST_TEXT.UNASSIGNED,
    label: MONITOR_LIST_TEXT.UNASSIGNED,
  });
  return {
    gsAssigneeOption,
    loading,
    error,
    refetch,
  };
};
